import React, { useEffect, useState } from "react";
import { inject, observer } from "mobx-react";
import { Button, message, Spin } from "antd";
import { useRequest } from "ahooks";
import { changeQrCode, verifyQrCode, addTaxOfficer } from "@/api/taxAuth";
import { parse } from "query-string";
import styles from "./index.less";
import TicketTitle from "@/components/ticketTitle";
import WhiteBox from "@/components/layout/whiteBox";
import AddTaxOfficerRenderQRcode from "./RenderQRcode";


const AddTaxOfficerQrCode = ({ taxHelperStore, ...props }) => {
  const [expired, setExpired] = useState(false);
  const [qrcodeId, setQrcodeId] = useState('');
  const [formData, setFormData] = useState({});

  const urlParams = parse(window.location.search);
  const { serialNo, province, fullName, idCard } = urlParams;

  // 获取二维码
  const { data: responseData, loading, refresh } = useRequest(
    () => changeQrCode({
      fullName,
      idCard,
      serialNo,
      area: province
    }),
    {
      onSuccess: (res) => {
        const businessData = res.data?.data?.data;
        if (businessData?.result === false) {
          const errorMessage = businessData?.message || '获取二维码失败';
          message.error(errorMessage);
          return;
        }

        setQrcodeId(res.data?.data?.data?.data?.qrcode_id || '');
        setFormData({ fullName, idCard, serialNo, area: province });
      },
      onError: (error) => {
        console.error('获取二维码失败:', error);
        const errorMessage = error.response?.data?.data?.data?.message ||
          error.response?.data?.message ||
          '获取二维码失败，请重试';
        message.error(errorMessage);
      }
    }
  );

  const data = responseData?.data?.data?.data?.data;

  const { run, cancel } = useRequest(
    () => verifyQrCode({
      serialNo,
      area: province,
      qrcodeId
    }),
    {
      manual: true,
      pollingInterval: 3000,
      onSuccess: (res) => {
        const { qrcode_status } = res.data?.data?.data.data;
        if (qrcode_status === '2') {
          cancel();
          runAddTaxOfficer();
          return;
        }
        // 二维码失效
        if (qrcode_status === '3') {
          cancel();
          setExpired(true);
          return;
        }
        // 待扫码 - 只有状态为1时才继续轮询
        if (qrcode_status === '1') {
          return;
        }
        // 其他状态停止轮询
        cancel();
        if (res.message) {
          message.error(res.message);
        }
      },
      onError: (error) => {
        console.error('验证二维码状态失败:', error);
        cancel();
      }
    }
  );

  // 轮询添加办税员状态
  const { run: runAddTaxOfficer, cancel: cancelAddTaxOfficer } = useRequest(
    () => addTaxOfficer({
      ...formData,
      qrcodeId
    }),
    {
      manual: true,
      pollingInterval: 3000,
      onSuccess: (res) => {

        const businessData = res.data?.data?.data;
        if (businessData?.code === '10000') {
          cancelAddTaxOfficer();
          message.success('办税员添加成功！');
          setTimeout(() => {
            window.location.href = `/authSuccess?serialNo=${serialNo}&watch=true`;
          }, 1500);
          return;
        }

        if (businessData?.code && businessData?.code !== '10000') {
          // 办理失败，显示错误信息并停止轮询
          cancelAddTaxOfficer();
          const errorMessage = businessData?.message || '办税员添加失败';
          message.error(errorMessage);
          return;
        }

      },
      onError: (error) => {
        console.error('添加办税员失败:', error);
        cancelAddTaxOfficer();
        const errorMessage = error.response?.data?.data?.data?.message ||
          error.response?.data?.message ||
          '办税员添加失败，请重试';
        message.error(errorMessage);
      }
    }
  );

  // 二维码获取成功后开始轮询
  useEffect(() => {
    if (data && !loading && qrcodeId) {
      run();
    }
  }, [data, loading, qrcodeId]);

  // 组件卸载时取消轮询
  useEffect(() => {
    return () => {
      cancel();
      cancelAddTaxOfficer();
    };
  }, []);

  const handleRefresh = () => {
    setQrcodeId('');
    refresh();
    setExpired(false);
  };

  return (
    <WhiteBox>
      <TicketTitle {...props} />
      <p className={styles.headerTitle}>
        请<span>法人</span>打开<span>电子税务局APP</span>扫描以下二维码，确认添加的办税员信息
      </p>

      <div className={styles.qrcodeContent}>
        <Spin spinning={loading} tip="二维码加载中...">
          <div className={styles.qrcodeBox}>
            {
              !loading && data?.qrcode && (
                <AddTaxOfficerRenderQRcode data={data} />
              )
            }
            {/* 二维码失效遮罩 */}
            {
              expired && (
                <div className={styles.mask} onClick={handleRefresh}>
                  <div>
                    二维码已失效，点击刷新
                  </div>
                </div>
              )
            }
          </div>
        </Spin>
        <p className={styles.validityTime}>
          二维码有效时间10分钟
        </p>
        <p className={styles.footerTitle}>办税员添加成功后，需办税员本人登录电子税务局确认身份，方可在本平台使用。</p>
      </div>
    </WhiteBox>
  );
};

export default inject("taxHelperStore")(observer(AddTaxOfficerQrCode));
